module.exports = __webpack_public_path__ + "img/IMG_1627.4afabde2.webp";